export const initialState = {
  professions: []
};
